import {
  FETCH_MASCOTA_INFO,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_MASCOTA,
  FETCHED_MASCOTA,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_mascota: false,
  processing_mascota: false,
};

const getters = {
  is_loading() {
    return state.loading_mascota;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  mascota_processing() {
    return state.processing_mascota;
  },
};

const actions = {
  [FETCH_MASCOTA_INFO](context, mascotaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_MASCOTA);
      ApiService.query(`mascotas/${mascotaId}`)
        .then(({ data }) => {
          context.commit(FETCHED_MASCOTA);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_MASCOTA);
        });
    });
  },
};

const mutations = {
  [FETCHING_MASCOTA](state) {
    state.loading_mascota = true;
  },
  [FETCHED_MASCOTA](state) {
    state.loading_mascota = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
